import { Component, OnInit, Input, ComponentFactory, ComponentFactoryResolver, ViewChild, ViewContainerRef, ComponentRef } from '@angular/core';
import { NodoEntity, FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity } from 'src/app/services/servicio-formato-asistencial.service';
import { FilaComponent } from '../fila/fila.component';

@Component({
  selector: 'app-panel',
  templateUrl: './panel.component.html',
  styleUrls: ['./panel.component.css']
})
export class PanelComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  @ViewChild('panelContainer', { read : ViewContainerRef }) panelContainer: ViewContainerRef;

  titulo: string;

  constructor( private componentFactory: ComponentFactoryResolver) { }

  ngOnInit() {
    if (this.nodo) {
      this.onProcess();
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    this.build();
  }

  build() {
    if (this.nodo && this.nodo.hijos && this.nodo.hijos.length > 0) {
      const hijos = this.nodo.hijos.sort((a: NodoEntity, b: NodoEntity) => a.orden - b.orden);
      let filas: { order: number, hijos: NodoEntity[]}[] = [] ;
      let order = 1;
      let filasHijos: NodoEntity[] = [];
      for (let i = 0; i < hijos.length; i++) {
        const hijo = hijos[i];

        if (( i + 1) === hijos.length) {
          filasHijos.push(hijo);
          filas.push({ order : order, hijos : filasHijos});
          order++;
          filasHijos = [];
        } else {
          if (filasHijos.length < 3) {
            filasHijos.push(hijo);
          } else {
            filas.push({ order : order, hijos : filasHijos });
            order++;
            filasHijos = [hijo];
          }
        }
      }

      filas = filas.sort((a: any, b: any) => a.orden - b.orden);
      filas.forEach((fila: any) => { this.getRow(fila.hijos); });
    }
  }

  getRow(nodos: NodoEntity[]): ComponentRef<FilaComponent> {
    const factory: ComponentFactory<FilaComponent> = this.componentFactory.resolveComponentFactory(FilaComponent);
    const component: ComponentRef<FilaComponent> = this.panelContainer.createComponent(factory);
      component.instance.filtros = this.filtros;
      component.instance.data = this.data;
      component.instance.nodos = nodos;
      component.instance.classShared = 'col-4';
    return component;
  }

}
